export default __webpack_public_path__ + "static/media/empty-students-list.3bd13c11.png";